import { AxisType, BarChartModel, CHART_TYPE, ColumnChartModel, CommonChartModel, PieChartModel } from "./chart.model";
import { DYNAMIC_IDENTIFIER } from "./common.model";
import { TITLE_TYPE } from "./dynamic-data-table.model";
import { AreaDropdown, centralArea, easternArea, EventDropdown, FieldNames, JobRoleDropdown, southernArea, TotalAmountText, TotalCountText, westernArea } from "./form-fields.model";

const AreaBillingYearChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: `<span>Amount</span>: <b>$ {point.y}</b><br/>`
    },
    dataSchema: {
        label: 'areaName',
        value: 'amount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            drillDownField: "dealerDetails",
            label: "dealerCode",
            value: "amount",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Cost</span>: <b>$ {point.dataset.amount}</b><br/>
                <span>Total # of Attendees - <b>{point.dataset.count}</b></span>
                `
            },
            titleSchema: {
                [FieldNames['Event']]:{
                    label: '',
                    title: `Billing trend of ${DYNAMIC_IDENTIFIER['drilldownField']} for Area billing trend for ${DYNAMIC_IDENTIFIER['selectedField']}`,
                    type: TITLE_TYPE['Dynamic']
                }
            },
        }
    },
    titleSchema: {
        [FieldNames['Event']]:{
            label: '',
            title: `Area billing trend for ${DYNAMIC_IDENTIFIER['selectedField']}`,
            type: TITLE_TYPE['Dynamic']
        }
    }, 
    xAxis: {
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    },
    dataLabels: {
        enabled: true,
        format: "{point.name}: " + `$` + "{point.y}"
    }

}
export const ElevateBillingAreaBillingYearChartSchema = {
    chartSchema : AreaBillingYearChart,
    chartType: CHART_TYPE['PieChart'],
    exportConfig: {
        fileName: 'Area_Billing_Trend_Dealers',
        exportMessage: "Area Billing Trend",
        isCamelCase:['dealer','dealerName','area'],
        schema: {
            dealer: "Dealer Code",
            dealerName: "Dealer Name",
            area: "Dealer Area",
            district: "Dealer District",
            amount: "Amount($)"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([{
            ...EventDropdown, payloadInfo: {
                [FieldNames['Event']]: ''
            },
            showSelect:false,
            isLoading:false
        }])
    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'amount'
    }]),
}

const BillingTrendsDealersChart: CommonChartModel = {
    ...structuredClone(BarChartModel),
    tooltip: {
        headerFormat:`<span>{point.y}</span>`,
        pointFormat: `
        <br/>
        <span>Dealer Name</span><span>: <b>{point.dataset.dealerName}</b></span><br/>
        <span>District</span>: <b><span>{point.dataset.district}</span></b><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>
        <span>Total # of Attendees - <b>{point.dataset.count}</b></span>
        `
    },
    dataSchema: {
        label: 'dealerCode',
        value: 'amount',
    },
    titleSchema: {
        [FieldNames['Event']]: {
            label: '',
            subLabel: '',
            title: 'Billing Trend across Dealers',
            subTitle: `For ${DYNAMIC_IDENTIFIER['selectedField']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        labels: {
            style: {
                fontSize: '8px',
            },
        },
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    }
}
const BillingTrendsJobRolesChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    tooltip: {
        pointFormat: `
        <br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>        
        <span>Total # of Attendees - <b>{point.dataset.totalCount}</b></span><br/>`
    },
    dataSchema: {
        label: 'jobRole',
        value: 'amount',
    },
    titleSchema: {
        [FieldNames['Event']]: {
            label: '',
            subLabel: '',
            title: 'Billing Trend across Job Roles',
            subTitle: `For ${DYNAMIC_IDENTIFIER['selectedField']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Job Roles',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    },
    series: [{
        color: '#7ab1e7',
        data: [],
        dataLabels: {
            enabled: false
        },
    }],
}
export const ElevateBillingTrendsJobRoleChartSchema = {
    chartSchema : BillingTrendsJobRolesChart,
    chartType: CHART_TYPE['ColumnChart'],
    exportConfig: {
        fileName: 'Billing_Trends_JobRole',
        exportMessage:"Billing Trends JobRole",        
        isCamelCase:['jobRole'],
        schema: {
            jobRole: "Job Role",
            amount: "Amount($)"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([{
            ...EventDropdown, payloadInfo: {
                [FieldNames['Event']]: ''
            },
            showSelect:false,
            isLoading:false
        }])
    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'amount'
    }]),
}

const BillingTrendsDealersAndJobRolesChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    tooltip: {
        pointFormat: `
        <br/>
        <span>Dealer Name</span><span>: <b>{point.dataset.dealerName}</b></span><br/>
        <span>Area Name</span><span>: <b>{point.dataset.area}</b></span><br/>
        <span>District</span><span>: <b>{point.dataset.district}</b></span><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.amount}</b><br/>
        <span>Total # of Attendees - <b>{point.dataset.count}</b></span>
        `
    },
    dataSchema: {
        label: 'dealerCode',
        value: 'amount',
    },
    titleSchema: {
        [FieldNames['Event']]: {
            label: '',
            subLabel: '',
            title: `Billing Trend across Dealers for ${DYNAMIC_IDENTIFIER['startKey']+FieldNames['JobRole']+DYNAMIC_IDENTIFIER['endkey']}`,
            subTitle: `For ${DYNAMIC_IDENTIFIER['startKey']+FieldNames['Event']+DYNAMIC_IDENTIFIER['endkey']}`,
            type: TITLE_TYPE['Dynamic']
        },
        [FieldNames['JobRole']]: {
            label: '',
            subLabel: '',
            title: `Billing Trend across Dealers for ${DYNAMIC_IDENTIFIER['startKey']+FieldNames['JobRole']+DYNAMIC_IDENTIFIER['endkey']}`,
            subTitle: `For ${DYNAMIC_IDENTIFIER['startKey']+FieldNames['Event']+DYNAMIC_IDENTIFIER['endkey']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        type: AxisType['Category'],
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    },
    series: [{
        color: '#7ab1e7',
        data: [],
        dataLabels: {
            enabled: false
        },
    }],
}
export const ElevateBillingTrendsDealersAndJobRolesChartChartSchema = {
    chartSchema : BillingTrendsDealersAndJobRolesChart,
    chartType: CHART_TYPE['ColumnChart'],
    exportConfig: {
        exportMessage: 'Billing Trends Dealers And Job Roles',
        fileName:'Billing_Trends_Dealers_And_Job_Roles',        
        isCamelCase:['jobRole','dealerName','area'],
        schema: {
            jobRole: "JOB ROLE",
            dealerCode:"DEALER CODE",
            dealerName: "DEALER NAME",
            area: "DEALER AREA",
            district: "DEALER DISTRICT",
            amount: "AMOUNT($)"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([
            {
                ...EventDropdown, payloadInfo: {
                    [FieldNames['Event']]: ''
                },
                showSelect:false,
                isLoading:false
            },
            {
                ...JobRoleDropdown, payloadInfo: {
                    [FieldNames['JobRole']]: ''
                },
                showSelect:false,
                isLoading:false
            },
        ])
    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'amount'
    }]),
}

const AttendenceCountDealersChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: ` <span><b>{point.y}</b></span><br/>`
    },
    dataSchema: {
        label: 'status',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Dealers'
            },
            drillDownField: "dealerDetails",
            label: "dealerCode",
            value: "count",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Dealer Name</span>: <b>{point.dataset.dealerName}</b><br/>
                <span>Area</span>: <b>{point.dataset.area}</b><br/>
                <span>District</span>: <b>{point.dataset.district}</b><br/>
                <span>Total # of Attendees -</span> <b>{point.dataset.count}</b><br/>`
            },
            titleSchema: {
                [FieldNames['Event']]:{
                    label: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by Dealer for ${DYNAMIC_IDENTIFIER['selectedField']}`,
                    type: TITLE_TYPE['Dynamic']
                }
            },
            dataLabels: {
                enabled: true,
                format: "{point.y}"
            },
        }
    },
    xAxis: {
        title: {
            text: 'Dealers',
        }
    },
    yAxis: {
        title: {
            text: 'No. of People',
        }
    },
    titleSchema: {
        [FieldNames['Event']]:{
            label: '',
            title: `Attendance count across Dealers for ${DYNAMIC_IDENTIFIER['selectedField']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },

}
export const ElevateBillingAttendenceCountDealersChartSchema = {
    chartSchema : AttendenceCountDealersChart,
    chartType: CHART_TYPE['PieChart'],
    exportConfig: {
        fileName: 'Billing_Attendence_Count_Dealers',
        exportMessage:'Billing Attendence Count Dealers',        
        isCamelCase:['dealerName','area'],
        schema: {
            dealerCode:"DEALER CODE",
            dealerName: "DEALER NAME",
            area: "DEALER AREA",
            district: "DEALER DISTRICT",
            status:"STATUS",
            amount: "AMOUNT($)"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([{
            ...EventDropdown, payloadInfo: {
                [FieldNames['Event']]: ''
            },
            showSelect:false,
            isLoading:false
        }])
    },
    infoFields: structuredClone([{
        ...TotalCountText, calculateBy: 'totalCount'
    }]),
}

const AttendenceCountJobRoleChart: CommonChartModel = {
    ...structuredClone(PieChartModel),
    tooltip: {
        headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
        pointFormat: ` <span><b>{point.y}</b></span><br/>`
    },
    dataSchema: {
        label: 'status',
        value: 'totalCount',
        drillDownConfig: {
            xAxis: {
                title: 'Job Roles'
            },
            drillDownField: "jobDetails",
            label: "jobRole",
            value: "count",
            type: CHART_TYPE['BarChart'],
            tooltip: {
                headerFormat: `<span style="font-size:11px">{point.name}</span><br>`,
                pointFormat: `
                <span>Job Role</span>: <b>{point.dataset.jobRole}</b><br/>
                <span>Total # of Attendees - </span> <b>{point.dataset.count}</b><br/>`
            },
            titleSchema: {
                [FieldNames['Event']]:{
                    label: '',
                    title: `${DYNAMIC_IDENTIFIER['drilldownField']} Count by Job Role for ${DYNAMIC_IDENTIFIER['selectedField']}`,
                    type: TITLE_TYPE['Dynamic']
                }
            },
            dataLabels: {
                enabled: true,
                format: "{point.y}"
            },
        }
    },
    xAxis: {
        title: {
            text: 'Job Roles',
        }
    },
    yAxis: {
        title: {
            text: 'No. of People',
        }
    },
    titleSchema: {
        [FieldNames['Event']]:{
            label: '',
            title: `Attendance count across Job Roles for ${DYNAMIC_IDENTIFIER['selectedField']}`,
            type: TITLE_TYPE['Dynamic']
        }
    },
}
export const ElevateBillingAttendenceCountJobRoleChartChartSchema = {
    chartSchema : AttendenceCountJobRoleChart,
    chartType: CHART_TYPE['PieChart'],
    exportConfig: {
        exportMessage: 'Attendence Count Job Role',
        fileName: 'Attendence_Count_Job_Role',        
        isCamelCase:['jobRole'],
        schema: {
            jobRole: "JOB ROLE",
            status: "STATUS",
            count: "COUNT"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([{
            ...EventDropdown, payloadInfo: {
                [FieldNames['Event']]: ''
            },
            showSelect:false,
            isLoading:false
        }])
    },
    infoFields: structuredClone([{
        ...TotalCountText, calculateBy: 'totalCount'
    }]),
}

export const ElevateBillingTrendsDealersChartSchema = {
    chartSchema : BillingTrendsDealersChart,
    chartType: CHART_TYPE['BarChart'],
    exportConfig: {
        fileName: 'Billing_Trends_Dealers',
        exportMessage:"Billing Trends Dealers",        
        isCamelCase:['dealerName','area'],
        schema: {
            dealerCode: "Dealer Code",
            dealerName: "Dealer Name",
            area: "Dealer Area",
            district: "Dealer District",
            amount: "Amount($)",
            [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']]
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([{
            ...EventDropdown, payloadInfo: {
                [FieldNames['Event']]: ''
            },
            showSelect:false,
            isLoading:false
        }])
    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'amount'
    }]),
}

const BillingAmountForYearChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    tooltip: {
        headerFormat:`<span>{point.y}</span>`,
        pointFormat: `
        <br/>
        <span>Year</span><span>: <b>{point.dataset.year}</b></span><br/>
        <span>Amount</span>: <b><span>$</span>{point.dataset.totalAmount}</b><br/>
        `
    },
    dataSchema: {
        label: 'year',
        value: 'totalAmount',
    },
    titleSchema: {
            label: '',
            subLabel: '',
            title: 'Billing Trend for Year',
            subTitle: '',
            type: TITLE_TYPE['Dynamic']
    },
    xAxis: {
        type: AxisType['Category'],
        labels: {
            style: {
                fontSize: '8px',
            },
        },
        title: {
            text: 'Year',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    }
}

export const ElevateBillingAmountForYearChartSchema = {
    chartSchema : BillingAmountForYearChart,
    chartType: CHART_TYPE['ColumnChart'],
    exportConfig: {
        fileName: "Billing_Trend_Year",
        exportMessage:"Billing Trend Year",
        schema: {
            year: "year",
            totalAmount: "Amount($)",
            [DYNAMIC_IDENTIFIER['selectedField']]: [FieldNames['Month']]
        }
    },
    filterSchema: {

    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'totalAmount'
    }]),
}

const BillingAmountForAreaChart: CommonChartModel = {
    ...structuredClone(ColumnChartModel),
    tooltip: {
        headerFormat:`<span>{point.y}</span>`,
        pointFormat: `
        <br/>
        <span>Area</span>: <b><span>{point.dataset.areaName}</span></b><br/>
         <span>Year</span><span>: <b>{point.dataset.year}</b></span><br/>
        <span>Total Amount</span>: <b><span>$</span>{point.dataset.totalAmount}</b><br/>
        `
    },
    dataSchema: {
        label: 'year',
        value: 'totalAmount',
    },
    titleSchema: {
        [FieldNames['Area']]: {
            label: '',
            subLabel: '',
            title: `Billing Trend in ${DYNAMIC_IDENTIFIER['selectedField']}`,
            subTitle: '',
            type: TITLE_TYPE['Dynamic']
        }
    },
    xAxis: {
        type: AxisType['Category'],
        labels: {
            style: {
                fontSize: '8px',
            },
        },
        title: {
            text: 'Year',
        }
    },
    yAxis: {
        title: {
            text: 'Cost ($)',
        }
    }
}
export const ElevateBillingAmountForAreaChartSchema = {
    chartSchema : BillingAmountForAreaChart,
    chartType: CHART_TYPE['ColumnChart'],
    exportConfig: {
        fileName: "Billing_Trend_Area",
        exportMessage:"Billing Trend Area",
        isCamelCase:['areaName'],
        schema: {
            areaName: "Area Name",
            year: "Year",
            totalAmount: "Amount($)"
        }
    },
    filterSchema: {
        FieldsArray: structuredClone([
            {...structuredClone(AreaDropdown), multiple: false, defaultValue: '31', showSelect: false,
                options: [{ fieldLabel: westernArea, fieldValue: '31' }, { fieldLabel: centralArea, fieldValue: '32' }, { fieldLabel: easternArea, fieldValue: '33' }, { fieldLabel: southernArea, fieldValue: '34' }, { fieldLabel: 'PUERTO RICO', fieldValue: '00' }]
            },
        ])
    },
    infoFields: structuredClone([{
        ...TotalAmountText, calculateBy: 'totalAmount'
    }]),
}